import _ from 'lodash';

export default formatProjectApi;

/**
 * @name formatProject
 * @description Format the Project (to API)
 * @param {object} project The project to be formatted
 * @return {object} Returns the project ready to send to the endpoint.
 */
function formatProjectApi(project) {
  let formattedProject = project;

  // Adjust the collector field value to the API standard.
  formattedProject.collector_id = project.collector;
  delete formattedProject.collector;

  // Process the Reference Photos
  if (project.referenceImages && project.referenceImages.length) {
    formattedProject.reference_images = [];
    _.each(project.referenceImages, function(photo) {
      if (photo.result.image && photo.result.image_1024 &&
      photo.result.image_341) {
        formattedProject.reference_images.push(photo.result);
      }
    });
  }

  // Process Coverup Photos
  if (project.coverupImages && project.coverupImages.length) {
    formattedProject.coverup_images = [];
    _.each(project.coverupImages, function(photo) {
      if (photo.result.image && photo.result.image_1024 &&
      photo.result.image_341) {
        formattedProject.coverup_images.push(photo.result);
      }
    });
  }

  // Process Completed Photos
  if (project.completedImages && project.completedImages.length) {
    formattedProject.completed_images = [];
    _.each(project.completedImages, function(photo) {
      if (photo.result.image && photo.result.image_1024 &&
      photo.result.image_341) {
        formattedProject.completed_images.push(photo.result);
      }
    });
  }
  return formattedProject;
}



// WEBPACK FOOTER //
// ./utils/format-project-api.js